const API_CONFIG: Record<string, string> = {
  "points.kisanet.fi": "https://kisanet.fi",
  "jt-staging-1.kisanet.fi": "https://staging-1.kisanet.fi",
  "jt-staging-2.kisanet.fi": "https://staging-1.kisanet.fi",
};

export function getApiBaseUrl(): string | undefined {
  const hostname = window.location.hostname.toLowerCase();
  return API_CONFIG[hostname] ?? import.meta.env.VITE_BASE_URL;
}
